// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3uMJZ","savePackageButton":"ClientWallet_savePackageButton__2YYoT"};